import EFL60 from '../assets/products/EFL060.png'
import EFL060DSMAX from '../assets/products/EFL060CADfiles/EFL0603dsMax.rar'
import EFL060DWG from '../assets/products/EFL060CADfiles/EFL060.dwg'
import EFL060DXF from '../assets/products/EFL060CADfiles/EFL060.dxf'
import EFL060PDF_INSTALL from '../assets/products/EFL060CADfiles/installation/EFL060_INSTALLATION.pdf'
import EFL060PDF_INSTALL_RUS from '../assets/products/EFL060CADfiles/installation/EFL060_УСТАНОВКА.pdf'
import EFL060PDF_MANUAL from '../assets/products/EFL060CADfiles/operation_manual/OPERATING_INSTRUCTIONS.pdf'
import EFL060PDF_MANUAL_RUS from '../assets/products/EFL060CADfiles/operation_manual/РУКОВОДСТВО_ЭКСПЛУАТАЦИИ.pdf'

import EFL90 from '../assets/products/EFL090.png'
import EFL090DSMAX from '../assets/products/EFL090CADfiles/EFL0903dsMax.rar'
import EFL090DWG from '../assets/products/EFL090CADfiles/EFL090.dwg'
import EFL090DXF from '../assets/products/EFL090CADfiles/EFL090.dxf'
import EFL090PDF_INSTALL from '../assets/products/EFL090CADfiles/installation/EFL090_INSTALLATION.pdf'
import EFL090PDF_INSTALL_RUS from '../assets/products/EFL090CADfiles/installation/EFL090_УСТАНОВКА.pdf'
import EFL090PDF_MANUAL from '../assets/products/EFL090CADfiles/operation_manual/OPERATING_INSTRUCTIONS.pdf'
import EFL090PDF_MANUAL_RUS from '../assets/products/EFL090CADfiles/operation_manual/РУКОВОДСТВО_ЭКСПЛУАТАЦИИ.pdf'

import EFL120 from '../assets/products/EFL120.png'
import EFL120DSMAX from '../assets/products/EFL120CADfiles/EFL1203dsMax.rar'
import EFL120DWG from '../assets/products/EFL120CADfiles/EFL120.dwg'
import EFL120DXF from '../assets/products/EFL120CADfiles/EFL120.dxf'
import EFL120PDF_INSTALL from '../assets/products/EFL120CADfiles/installation/EFL120_INSTALLATION.pdf'
import EFL120PDF_INSTALL_RUS from '../assets/products/EFL120CADfiles/installation/EFL120_УСТАНОВКА.pdf'
import EFL120PDF_MANUAL from '../assets/products/EFL120CADfiles/operation_manual/OPERATING_INSTRUCTIONS.pdf'
import EFL120PDF_MANUAL_RUS from '../assets/products/EFL120CADfiles/operation_manual/РУКОВОДСТВО_ЭКСПЛУАТАЦИИ.pdf'

import EFL150 from '../assets/products/EFL150.png'
import EFL150DSMAX from '../assets/products/EFL150CADfiles/EFL1503dsMax.rar'
import EFL150DWG from '../assets/products/EFL150CADfiles/EFL150.dwg'
import EFL150DXF from '../assets/products/EFL150CADfiles/EFL150.dxf'
import EFL150PDF_INSTALL from '../assets/products/EFL150CADfiles/installation/EFL150_INSTALLATION.pdf'
import EFL150PDF_INSTALL_RUS from '../assets/products/EFL150CADfiles/installation/EFL150_УСТАНОВКА.pdf'
import EFL150PDF_MANUAL from '../assets/products/EFL150CADfiles/operation_manual/OPERATING_INSTRUCTIONS.pdf'
import EFL150PDF_MANUAL_RUS from '../assets/products/EFL150CADfiles/operation_manual/РУКОВОДСТВО_ЭКСПЛУАТАЦИИ.pdf'

import EFL180 from '../assets/products/EFL180.png'
import EFL180DSMAX from '../assets/products/EFL180CADfiles/EFL1803dsMax.rar'
import EFL180DWG from '../assets/products/EFL180CADfiles/EFL180.dwg'
import EFL180DXF from '../assets/products/EFL180CADfiles/EFL180.dxf'
import EFL180PDF_INSTALL from '../assets/products/EFL180CADfiles/installation/EFL180_INSTALLATION.pdf'
import EFL180PDF_INSTALL_RUS from '../assets/products/EFL180CADfiles/installation/EFL180_УСТАНОВКА.pdf'
import EFL180PDF_MANUAL from '../assets/products/EFL180CADfiles/operation_manual/OPERATING_INSTRUCTIONS.pdf'
import EFL180PDF_MANUAL_RUS from '../assets/products/EFL180CADfiles/operation_manual/РУКОВОДСТВО_ЭКСПЛУАТАЦИИ.pdf'

import EFL210 from '../assets/products/EFL210.png'
import EFL210DSMAX from '../assets/products/EFL210CADfiles/EFL2103dsMax.rar'
import EFL210DWG from '../assets/products/EFL210CADfiles/EFL210.dwg'
import EFL210DXF from '../assets/products/EFL210CADfiles/EFL210.dxf'
import EFL210PDF_INSTALL from '../assets/products/EFL210CADfiles/installation/EFL210_INSTALLATION.pdf'
import EFL210PDF_INSTALL_RUS from '../assets/products/EFL210CADfiles/installation/EFL210_УСТАНОВКА.pdf'
import EFL210PDF_MANUAL from '../assets/products/EFL210CADfiles/operation_manual/OPERATING_INSTRUCTIONS.pdf'
import EFL210PDF_MANUAL_RUS from '../assets/products/EFL210CADfiles/operation_manual/РУКОВОДСТВО_ЭКСПЛУАТАЦИИ.pdf'

export const cards = [
  {
    title: 'EFL 060',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting',
    imgUrl: EFL60,
    translate: 'technicalERF060',
    cad: {
      smaxZip: EFL060DSMAX,
      dwg: EFL060DWG,
      dxf: EFL060DXF,
    },
    manuals: {
      englishPdf: EFL060PDF_MANUAL,
      russianPdf: EFL060PDF_MANUAL_RUS,
    },
    installation: {
      englishPdf: EFL060PDF_INSTALL,
      russianPdf: EFL060PDF_INSTALL_RUS,
    },
  },
  {
    title: 'EFL 090',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting',
    imgUrl: EFL90,
    translate: 'technicalERF090',
    cad: {
      smaxZip: EFL090DSMAX,
      dwg: EFL090DWG,
      dxf: EFL090DXF,
    },
    manuals: {
      englishPdf: EFL090PDF_MANUAL,
      russianPdf: EFL090PDF_MANUAL_RUS,
    },
    installation: {
      englishPdf: EFL090PDF_INSTALL,
      russianPdf: EFL090PDF_INSTALL_RUS,
    },
  },
  {
    title: 'EFL 120',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting',
    imgUrl: EFL120,
    translate: 'technicalERF120',
    cad: {
      smaxZip: EFL120DSMAX,
      dwg: EFL120DWG,
      dxf: EFL120DXF,
    },
    manuals: {
      englishPdf: EFL120PDF_MANUAL,
      russianPdf: EFL120PDF_MANUAL_RUS,
    },
    installation: {
      englishPdf: EFL120PDF_INSTALL,
      russianPdf: EFL120PDF_INSTALL_RUS,
    },
  },
  {
    title: 'EFL 150',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting',
    imgUrl: EFL150,
    translate: 'technicalERF150',
    cad: {
      smaxZip: EFL150DSMAX,
      dwg: EFL150DWG,
      dxf: EFL150DXF,
    },
    manuals: {
      englishPdf: EFL150PDF_MANUAL,
      russianPdf: EFL150PDF_MANUAL_RUS,
    },
    installation: {
      englishPdf: EFL150PDF_INSTALL,
      russianPdf: EFL150PDF_INSTALL_RUS,
    },
  },
  {
    title: 'EFL 180 XL',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting',
    imgUrl: EFL180,
    translate: 'technicalERF180',
    cad: {
      smaxZip: EFL180DSMAX,
      dwg: EFL180DWG,
      dxf: EFL180DXF,
    },
    manuals: {
      englishPdf: EFL180PDF_MANUAL,
      russianPdf: EFL180PDF_MANUAL_RUS,
    },
    installation: {
      englishPdf: EFL180PDF_INSTALL,
      russianPdf: EFL180PDF_INSTALL_RUS,
    },
  },
  {
    title: 'EFL 210 XXL',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting',
    imgUrl: EFL210,
    translate: 'technicalERF210',
    cad: {
      smaxZip: EFL210DSMAX,
      dwg: EFL210DWG,
      dxf: EFL210DXF,
    },
    manuals: {
      englishPdf: EFL210PDF_MANUAL,
      russianPdf: EFL210PDF_MANUAL_RUS,
    },
    installation: {
      englishPdf: EFL210PDF_INSTALL,
      russianPdf: EFL210PDF_INSTALL_RUS,
    },
  },
]

export const LinkItems = [
  { name: 'products', to: '/products' },
  { name: 'about', to: '/about' },
  { name: 'contact', to: '/contact' },
]
